import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { OrdersService } from '../../providers/order/orders.service';

@IonicPage()
@Component({
  selector: 'page-ticket-modal',
  templateUrl: 'ticket-modal.html',
})
export class TicketModalPage {
  idOrder: number;
  printButton = true;
  order: any = {};
  elements: any[] = [];
  menus: any[] = [];
  paymentModes: any[] = [];
  ticketContent : any;
  num : null;
  constructor(public navCtrl: NavController,
    private viewCtr : ViewController,
    public navParams: NavParams,
    private ordersService: OrdersService) {
  }

  ionViewDidLoad() {
  }
  ngOnInit() {
    this.idOrder = this.navParams.get('order');
    if(this.idOrder && this.idOrder !=0){
      this.ordersService.getOrderTicket(this.idOrder).subscribe(
        (resp: any)=>{
          this.ticketContent = resp.template;
          this.num = resp.num;
        }
      )
    }
    if (this.idOrder != 0) {
      this.ordersService.getOrder(this.idOrder).subscribe(
        order => {
          this.order = order;
        }
      )
      this.ordersService.getOrderElements(this.idOrder).subscribe(
        (elements: any[]) => {
          this.elements = elements;
        }
      )
      this.ordersService.getOrderMenus(this.idOrder).subscribe(
        (menus: any[]) => {
          this.menus = menus;
        }
      )
      this.ordersService.getOrderPaymentModes(this.idOrder).subscribe(
        (paymentModes: any[]) => {
          this.paymentModes = paymentModes;
        }
      )
    }
  }
closeModal(){
  this.viewCtr.dismiss();
}
}



// WEBPACK FOOTER //
// ./src/pages/ticket-modal/ticket-modal.ts